import React, { useState } from 'react';
import ReactLoading from 'react-loading';
import { HiStar, HiOutlineStar } from 'react-icons/hi2';
import './SurveyDeliveryModal.css';

// داده‌های آزمایشی - بعداً می‌توانید این را از props دریافت کنید
const MOCK_ITEMS = [
    { id: 1, name: 'کالای تستی شماره یک' },
    { id: 2, name: 'کالای تستی شماره دو' },
];

export const SurveyDeliveryModal = ({ isOpen, onClose, onSubmit, isSubmitting }) => {
    // ذخیره امتیازات به شکل: { 1: 4, 2: 5 } (شناسه کالا: تعداد ستاره)
    const [ratings, setRatings] = useState({});

    if (!isOpen) return null;

    const handleStarClick = (itemId, starValue) => {
        setRatings(prev => ({
            ...prev,
            [itemId]: starValue
        }));
    };

    const handleSubmit = () => {
        // تبدیل آبجکت امتیازات به یک آرایه برای ارسال به بک‌اند
        const ratingsArray = Object.keys(ratings).map(key => ({
            item_id: parseInt(key),
            rate: ratings[key]
        }));
        
        onSubmit(ratingsArray);
    };

    return (
        <div className="survey-modal-overlay">
            <div className="survey-modal-content">
                <div className="survey-modal-header">
                    <h3>نظرسنجی و تایید تحویل</h3>
                    <p>لطفاً میزان رضایت خود را از کالاهای دریافتی مشخص کنید.</p>
                </div>

                <div className="survey-modal-body">
                    {MOCK_ITEMS.map((item) => (
                        <div key={item.id} className="survey-item">
                            <span className="survey-item-name">{item.name}</span>
                            <div className="survey-stars">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <button
                                        key={star}
                                        type="button"
                                        className="star-btn"
                                        onClick={() => handleStarClick(item.id, star)}
                                    >
                                        {star <= (ratings[item.id] || 0) ? (
                                            <HiStar className="star-icon filled" />
                                        ) : (
                                            <HiOutlineStar className="star-icon empty" />
                                        )}
                                    </button>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="survey-modal-footer">
                    <button 
                        className="survey-cancel-btn" 
                        onClick={onClose}
                        disabled={isSubmitting}
                    >
                        انصراف
                    </button>
                    <button 
                        className="survey-submit-btn" 
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <ReactLoading type="spin" color="#ffffff" height={20} width={20} />
                        ) : (
                            'ثبت و تایید تحویل'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};
